import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const Loader24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path fillRule='evenodd' clipRule='evenodd' d='M12 3c0 .552-.45.994-.997 1.062a8 8 0 1 0 8.935 8.935c.068-.548.51-.997 1.062-.997s1.005.449.95.998A10 10 0 1 1 11.002 2.05c.55-.055.998.398.998.95Z' /></svg>);
